<template>
  <CCard>
    <CCardBody>
      <ListTable        
        :loading="loading"
        :items="items" 
        :fields="fields" 
        :showPagination="false" 
        @row-clicked="handleRowClick" />
    </CCardBody>
  </CCard>
</template>

<script>
  import {mapActions} from 'vuex';

  import ListTable from '@/components/ListTable';
  import comminMixin from '@/mixins/common/commonMixin';

  export default {
    mixins: [comminMixin],
    components: {
      ListTable
    },
    data () {
      return {
        items: [
        ],
        fields: [
          { key: 'user', label: this.$t('User'), _style:'width:300px' },
          { key: 'total_tips', label: this.$t('Total Tips'), _style:'' },
          { key: 'pending_tips', label: this.$t('Pending Tips'), _style:'' },
          { key: 'roi', label: this.$t('ROI%'), _style:'' },
          { key: 'profit_pts', label: this.$t('Profit pts'), _style:'' },
          { key: 'w_rate', label: this.$t('W/rate'), _style:'' },
          { key: 'avg_odd', label: this.$t('Avg Odd'), _style:'' },
          { key: 'followers', label: this.$t('Followers'), _style:'' },
          { key: 'actions', label: this.$t('Follow'), _style:'' },
        ],
        refreshKey: 0,
      }
    },
    methods: {
      ...mapActions(['getSubscribedUsers', 'toggleFollowUser']),
      getData() { 
        this.items = [];
        this.loading = true;
        this.getSubscribedUsers({site_use: "goaltrader"}).then(({data: {users, stats}}) => {
          users.forEach(uItem => {
            let fResult = stats.find(sItem => sItem._id === uItem._id);
            let actions = [];
            let user_id = localStorage.getItem('user_id');
            if(uItem._id !== parseInt(user_id)) {
              actions.push({
                type: 'switch',
                funcAction: this.handleChange
              });
            }
            this.items.push({
              user_id: uItem._id,
              user: uItem.alias,
              user_info: {
                url: `${uItem.avatar}`,
                name: uItem.alias,
              },
              total_tips: fResult ? fResult.totalCount : 0,
              pending_tips: fResult ? fResult.totalCount - fResult.settledWin - fResult.settledLose : 0,
              roi: fResult && fResult.stakeTotal ? parseFloat((fResult.profitPTS / fResult.stakeTotal * 100).toFixed(2)) : 0,
              profit_pts: fResult ? parseFloat(fResult.profitPTS.toFixed(2)) : 0,
              w_rate: fResult && (fResult.settledWin + fResult.settledLose) ? parseFloat(((fResult.settledWin / (fResult.settledWin + fResult.settledLose)) * 100).toFixed(2)) : 0,
              avg_odd: fResult && (fResult.settledLose + fResult.settledWin) ? ((fResult.totalOdd / (fResult.settledLose + fResult.settledWin))).toFixed(2) : 0,
              followers: uItem.followers,
              isFollowed: uItem.isFollowed,
              actions,
              refreshKey: 0
            })
          });
        }).catch(err => console.log(err)).finally(() => {
          this.loading = false;
        });
      },
      handleChange(val, toUserId) {
        let user_id = localStorage.getItem('user_id');
        let idx = this.items.findIndex( item => item.user_id === toUserId);
        console.log("=== idx", idx)
        let params = {
          toUserId: toUserId,
          fromUserId: parseInt(user_id)
        };
        console.log("=== params", params)
        try {
          this.toggleFollowUser(params).then(({status}) => {
            if(status === 'success') {
              if(val) {
                this.items[idx].followers ++;
              } else {
                this.items[idx].followers --;
              }
            }
          })
        } catch(err) {
          console.log(err);
        }
      },
      handleRowClick(user_id) {
        this.$router.push({
          name: 'UserTipStat',
          params: { id: user_id}
        });
      }
    },
    created() {
      this.getData();
    },
    watch: {
    
    },
    mounted() {
      this.sockets.subscribe('UpdateUserOnlineStatus', ({onlineUsers, offlineUsers}) => {
          for (let i=0; i < this.items.length; i++) {
              if (onlineUsers.includes(this.items[i].user_id)) {
                this.items[i].online = true;
                console.log(this.items[i].user_id)
              }
                  
              else
                  this.items[i].online = false;

              this.items[i].refreshKey ++;
          }
      });
    }
  }
</script>
